import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Firestore, collectionData, deleteDoc } from '@angular/fire/firestore';
import { CollectionReference, DocumentData, addDoc, collection, doc, getDocs, query, updateDoc, where } from 'firebase/firestore';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SharedService } from './shared.service';


@Injectable({
    providedIn: 'root'
})
export class LikesService {
    httpUrl = environment.url;
    likes: any;
    likesCollection: CollectionReference<DocumentData>;
    videolikesCollection: CollectionReference<DocumentData>;
    commentsCollection: CollectionReference<DocumentData>;

    private pipValueSubject: BehaviorSubject<any> = new BehaviorSubject<any>('close');
    pipValue$: Observable<any> = this.pipValueSubject.asObservable();

	playValueSubject: BehaviorSubject<any> = new BehaviorSubject<any>(false);
    playValue$: Observable<any> = this.playValueSubject.asObservable();

	selectedPodcastValue: BehaviorSubject<any> = new BehaviorSubject<any>({});
    selectedPodcastValue$: Observable<any> = this.selectedPodcastValue.asObservable();

	currentTimeValue: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    currentTime$: Observable<any> = this.currentTimeValue.asObservable();

    constructor(
        private httpClient: HttpClient,
        private firestore: Firestore,
		private sharedService: SharedService
    ) {
        this.likesCollection = collection(this.firestore, "likes");
        this.videolikesCollection = collection(this.firestore, "videoLikes");
        this.commentsCollection = collection(this.firestore, "comments");
    }

    async ngOnInit() { }

    getLikes() {
        const likesRef = collection(this.firestore, 'likes');
        return collectionData(likesRef, { idField: 'id' }) as Observable<any>;
    }

    async addLike(data: any, docId: string) {
        try {
            const docRef = await addDoc(collection(this.firestore, 'likes'), data);
			return docRef.id;
        } catch (err) {
            console.log('Unable to save data', err);
        }
    }

	async removeLike(likeDocId: string) {
		try {
			const docRef = doc(this.likesCollection, likeDocId);
			await deleteDoc(docRef);
		} catch (err) {
			console.log("Unable to delete like");
		}
	}

    async updateLike(data: any, docId: string) {
        if (!docId) {
            docId = doc(this.likesCollection).id;
        }
        data.id = docId;
        try {
            const docRef = doc(this.likesCollection, data.id);
            // await addDoc(collection(this.firestore, 'likes'), data);
            await updateDoc(docRef, data);
        } catch (err) {
            console.log('Unable to save data', err);
        }
    }

    setPIPValue(value: any) {
        // console.log('value in service', value)
        this.pipValueSubject.next(value);
    }

    getPIPValue(): Observable<any> {
        return this.pipValue$;
    }

	async getUserLikes(userId: string) {
		try {
			const q = query(collection(this.firestore, "likes"), where("userId", "==", userId));
			const likesData = collectionData(q, { idField: 'id' });
			return await this.sharedService.getObservableRes(likesData);
		} catch (err) {
			console.log(err);
		}
	}

	async getUserComments(userId: string) {
		try {
			const q = query(collection(this.firestore, "comments"), where("userId", "==", userId));
			const likesData = collectionData(q, { idField: 'id' });
			return await this.sharedService.getObservableRes(likesData);
		} catch (err) {
			console.log(err);
		}
	}

	async saveComment(text: string, entityId: string, userId: string) {
		try {
			const data = {
				entityId,
				entityType: "podcast",
				userId,
				text,
				createdAt: new Date()
			};

			await addDoc(collection(this.firestore, "comments"), data);
		} catch (err) {
			console.log("Unable to save comment!")
		}
	}

    // quote -------
    async likeQuote(likeData:any) {
        try {
            await addDoc(this.likesCollection, likeData);
            return true;
        } catch (error:any) {
            console.log('Error while liking quote:', error.message)
            return false;
        }
    }
    async unlikeQuote(entityId:any, userId:any) {
        try {
            const q = query(this.likesCollection,
                            where("entityId", "==", entityId),
                            where("userId", "==", userId));
            const querySnapshot = await getDocs(q);

            querySnapshot.forEach(async (doc) => {
                await deleteDoc(doc.ref);
            });
        } catch (error:any) {
            console.log("Error while unliking quote: ", error.message);
        }
    }

    checkIsQuoteLiked(entityId:any, userId:any) {
        try {
            //         const q = query(this.likesCollection,
            //                         where("entityId", "==", entityId),
            //                         where("userId", "==", userId));
            //         const querySnapshot = await getDocs(q);
            //         return !querySnapshot.empty;
            const q = query(this.likesCollection,
                            where("entityId", "==", entityId),
                            where("userId", "==", userId));

            return collectionData(q, { idField: 'id' });
        } catch (error:any) {
            console.log("Error while checking if quote is liked:", error.message);
        }
    }

    // video -------
    async likeVideo(likeData:any) {
        try {
            await addDoc(this.videolikesCollection, likeData);
        } catch (error:any) {
            console.log('Error while liking video:', error.message)
        }
    }

    async unlikeVideo(ids:any) {
        try {
            const q = query(this.videolikesCollection,
                            where("programId", "==", ids.programId),
                            where("sectionId", "==", ids.sectionId),
                            where("topicId", "==", ids.topicId),
                            where("userId", "==", ids.userId)
                        );
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                for (const doc of querySnapshot.docs) {
                    // console.log('Deleting document:', doc.id);
                    await deleteDoc(doc.ref);
                    // console.log('Document deleted:', doc.id);
                }
            } else {
                console.log('No documents found to delete.');
            }
        } catch (error:any) {
            console.log("Error while unliking video: ", error.message);
        }
    }

    checkIsVideoLiked(ids:any) {
        try {
            const q = query(this.videolikesCollection,
                            where("programId", "==", ids.programId),
                            where("sectionId", "==", ids.sectionId),
                            where("topicId", "==", ids.topicId),
                            where("userId", "==", ids.userId)
                    );

            return collectionData(q, { idField: 'id' });
        } catch (error:any) {
            console.log("Error while checking if video is liked:", error.message);
        }
    }

    // video comment --------
    async saveVideoComment(commentData:any) {
        try {
            await addDoc(this.commentsCollection, commentData)
            return true;
        } catch (error:any) {
            console.log('Error while submit comment:', error.message)
            return false;
        }
    }

    getVideoComments(ids:any) {
        try {
            const q = query(this.commentsCollection,
                            where("programId", "==", ids.programId),
                            where("sectionId", "==", ids.sectionId),
                            where("topicId", "==", ids.topicId),
                            where("userId", "==", ids.userId),
                            where("entityType", "==", ids.entityType),
                    );

            return collectionData(q, { idField: 'id' });
        } catch (error:any) {
            console.log("Error while getting video comments:", error.message);
        }
    }

}
